module.exports = __webpack_public_path__ + "img/send.f1a25e1c.svg";